import OfferModalInit from "./offerModal.js";

document.addEventListener("DOMContentLoaded", function (event) {
  OfferModalInit();
});
